import { API_VERSIONS } from '@oup/shared-node-browser/constants';
import signedFetch from '../util/signedFetch.js';

export default orgId =>
  signedFetch('getOrgDetails', `${__API_BASE__}/org/${encodeURIComponent(orgId)}?withoutUsers=true`, 'GET', undefined, {
    Accept: API_VERSIONS.API_VERSION_0_2,
    'Content-Type': 'application/json'
  });
